import VALID_ON_FILTER_GUARD from '@/core/guards/valid-on-filter.guard';
import { PAYMENT_SYSTEM_FILTER_GUARD } from '@/core/guards/payment-system.guard';
import { RouteRecordRaw } from 'vue-router';

const employerRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'EmployersOverview',
      component: () => import('@/modules/employer/pages/EmployersOverview.vue'),
   },
   {
      path: ':id',
      name: 'EmployerDetails',
      component: () => import('@/modules/employer/pages/EmployerDetails.vue'),
      meta: { skipTitleGuard: true },
      children: [
         {
            path: 'commercial-agreements',
            alias: '',
            name: 'EmployerCommercialAgreements',
            beforeEnter: [VALID_ON_FILTER_GUARD],
            component: () =>
               import('@/modules/employer/components/employer-details/commercial-agreements/EmployerCommercialAgreements.vue'),
         },
         {
            path: 'performance-data',
            name: 'EmployerPerformanceData',
            component: () => import('@/modules/employer/components/employer-details/performance-data/EmployerPerformanceData.vue'),
            children: [
               {
                  path: '',
                  name: 'EmployerPerformanceCodeTriggers',
                  component: () =>
                     import('@/modules/employer/components/employer-details/performance-code-triggers/EmployerPerformanceCodeTriggers.vue'),
               },
               {
                  path: 'mail-performances',
                  name: 'EmployerPerformanceDataMailPerformance',
                  component: () =>
                     import('@/modules/employer/components/employer-details/performance-data/EmployerPerformanceDataMailPerformance.vue'),
               },
               {
                  path: 'limits',
                  name: 'EmployerPerformanceDataLimits',
                  component: () =>
                     import('@/modules/employer/components/employer-details/performance-data/employer-performance-data-limits/EmployerPerformanceDataLimits.vue'),
               },
            ],
         },
         {
            path: 'work-material-types',
            name: 'EmployerWorkMaterialTypes',
            component: () => import('@/modules/employer/components/employer-details/work-material-types/EmployerWorkMaterialTypes.vue'),
         },
         {
            path: 'job-profiles',
            name: 'EmployerJobProfiles',
            component: () => import('@/modules/employer/components/employer-details/employer-job-profiles/EmployerJobProfiles.vue'),
         },
         {
            path: 'payment-system',
            name: 'EmployerPaymentSystem',
            component: () => import('@/modules/employer/components/employer-details/payment-system/EmployerPaymentSystem.vue'),
            children: [
               {
                  path: '',
                  name: 'EmployerPaymentSystemPerformanceCodes',
                  beforeEnter: [PAYMENT_SYSTEM_FILTER_GUARD],
                  component: () =>
                     import('@/modules/employer/components/employer-details/payment-system-performance-codes/EmployerPaymentSystemPerformanceCodes.vue'),
               },
               {
                  path: 'payment-system-teams',
                  name: 'EmployerPaymentSystemTeams',
                  beforeEnter: [PAYMENT_SYSTEM_FILTER_GUARD],
                  component: () =>
                     import('@/modules/employer/components/employer-details/payment-system-teams/EmployerPaymentSystemTeams.vue'),
               },
               {
                  path: 'payment-system-job-functions',
                  name: 'EmployerPaymentSystemJobFunctions',
                  beforeEnter: [PAYMENT_SYSTEM_FILTER_GUARD],
                  component: () =>
                     import('@/modules/employer/components/employer-details/payment-system-job-functions/EmployerPaymentSystemJobFunctions.vue'),
               },
            ],
         },
         {
            path: 'salary-indexations',
            name: 'EmployerSalaryIndexations',
            component: () => import('@/modules/employer/components/employer-details/salary-indexations/SalaryIndexations.vue'),
            beforeEnter: (to, from, next) => {
               if (!to.query.sort) {
                  return next({ path: to.path, query: { sort: '-indexation_date' } });
               }

               return next();
            },
         },
         {
            path: 'documents',
            name: 'EmployerDocuments',
            component: () => import('@/modules/employer/components/employer-details/employer-documents/EmployerDocuments.vue'),
         },
         {
            path: 'integrations',
            name: 'EmployerIntegrations',
            component: () => import('@/modules/employer/components/employer-details/employer-integrations/EmployerIntegrations.vue'),
            children: [
               {
                  path: '',
                  alias: 'unified-post',
                  name: 'EmployerUnifiedPost',
                  component: () => import('@/modules/employer/components/employer-details/employer-integrations/EmployerUnifiedPost.vue'),
               },
               {
                  path: 'etm',
                  alias: 'etm',
                  name: 'EmployerETMSettings',
                  component: () => import('@/modules/employer/components/employer-details/employer-integrations/EmployerETMSettings.vue'),
               },
            ],
         },
         {
            path: 'frontier-workers',
            name: 'EmployerFrontierWorkers',
            component: () => import('@/modules/employer/components/employer-details/employer-frontier-workers/EmployerFrontierWorkers.vue'),
         },
         {
            path: 'service-notifications',
            name: 'EmployerServiceNotifications',
            component: () =>
               import('@/modules/employer/components/employer-details/employer-service-notifications/EmployerServiceNotifications.vue'),
         },
         {
            path: 'case-file-templates',
            name: 'EmployerCaseFileTemplates',
            component: () => import('@/modules/employer/components/employer-details/case-file-templates/EmployerCaseFileTemplates.vue'),
         },
      ],
   },
];

export default employerRoutes;
